import { render, staticRenderFns } from "./rotate-overlay.vue?vue&type=template&id=5c880350"
import script from "./rotate-overlay.vue?vue&type=script&lang=js"
export * from "./rotate-overlay.vue?vue&type=script&lang=js"
import style0 from "./rotate-overlay.vue?vue&type=style&index=0&id=5c880350&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports